import React from "react";
import "./Components.css";

interface ILoading {
  spinnerSize?: string;
}

function Loading(props: ILoading) {
  const { spinnerSize } = props;
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        className="spinner"
        style={{
          width: spinnerSize ? spinnerSize : "75px",
          height: spinnerSize ? spinnerSize : "75px",
        }}
      >
        <div></div>
        <div></div>
      </div>
    </div>
  );
}

export default Loading;
